import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { User } from "lucide-react";
import { useAuth } from "../../hooks/useAuth";
import "../../styles/navbar.css";

export default function Navbar() {
  const { isAuthenticated, accountId, logout } = useAuth();
  const navigate = useNavigate();
  const isAdmin = localStorage.getItem("gs_is_admin") === "true";

  function handleLogout() {
    logout();
    navigate("/login");
  }

  return (
    <nav className="gs-navbar">
      <NavLink to="/" className="gs-navbar-brand">
        <img src="/rs-logo.png" alt="GreenSetu" />
        <span>GreenSetu</span>
      </NavLink>

      <div className="gs-navbar-links">
        <NavLink
          to="/dashboard"
          className={({ isActive }) => "gs-navbar-link" + (isActive ? " active" : "")}
        >
          Dashboard
        </NavLink>
        <NavLink
          to="/screening"
          className={({ isActive }) => "gs-navbar-link" + (isActive ? " active" : "")}
        >
          Screening
        </NavLink>
        {isAdmin && (
          <NavLink
            to="/admin"
            className={({ isActive }) => "gs-navbar-link" + (isActive ? " active" : "")}
          >
            Admin
          </NavLink>
        )}
      </div>

      <div className="gs-navbar-spacer" />

      <div className="gs-navbar-right">
        {isAuthenticated && (
          <NavLink
            to="/profile"
            className={({ isActive }) => "gs-navbar-profile" + (isActive ? " active" : "")}
            title="Profile & Settings"
          >
            <User size={15} />
            <span>Profile</span>
          </NavLink>
        )}
        {isAuthenticated ? (
          <button className="gs-navbar-logout" onClick={handleLogout}>
            Log out
          </button>
        ) : (
          <NavLink
            to="/login"
            style={{
              padding: "0.4rem 1rem",
              background: "#1a6b3c",
              color: "#fff",
              borderRadius: "8px",
              textDecoration: "none",
              fontSize: "0.82rem",
              fontWeight: 600,
            }}
          >
            Sign in
          </NavLink>
        )}
      </div>
    </nav>
  );
}
